(() => {
  const root = window.Shopify?.routes?.root || '/';
  const host = document.querySelector('dod-welcome-gift');
  const config = host ? JSON.parse(host.querySelector('[data-gift-copy]').textContent) : {};
  const offerReady = host?.dataset.checkoutReady === 'true' && host.dataset.designMode !== 'true';
  const legacyGames = ["4388068032593","6647592681553","8550716309819","8550720733499","8852198129979","8550722404667","8852200849723","10562206925115","8550717653307","10562202337595","10562205614395","10562204303675","10562206171451","15414764929339","9429622915387","8852085571899","15414755066171","15414762635579","15414777053499","15414769320251"];
  const diceGames = ['15433583624507','15434026615099'];
  const games = new Set([...(offerReady ? config.paid_games : legacyGames),...diceGames].map(String));
  const giftProducts = new Set(['15429919965499','15429920227643']);
  const giftVariants = new Set((config.gift_variants || []).map(String));
  const offerCode = 'LN-GIFT-GAMES-2026';
  const storageKey = 'dod-ln-pending-gift';
  const owned = code => /^(CHATGAMES[234]-(20|30|40)|CHATPAIR50-\d+|CHATADD50-ACTOUT|LN-GIFT-GAMES-2026)$/i.test(code);
  let pending = '';
  try { pending = sessionStorage.getItem(storageKey) || ''; } catch (_) {}
  if (!giftVariants.has(pending)) pending = '';
  const reserve = id => {
    pending = giftVariants.has(String(id)) ? String(id) : '';
    try { pending ? sessionStorage.setItem(storageKey,pending) : sessionStorage.removeItem(storageKey); } catch (_) {}
  };
  let queue = Promise.resolve();
  let queuedSyncs = 0;
  let holds = 0;
  const begin = () => {
    holds++;
    document.querySelectorAll('[name="checkout"]').forEach(button => {
      if (!button.disabled) { button.dataset.dodTierLock = 'true'; button.disabled = true; }
    });
    let released = false;
    return () => {
      if (released) return;
      released = true;
      holds--;
      if (!holds) document.querySelectorAll('[data-dod-tier-lock]').forEach(button => {
        delete button.dataset.dodTierLock;
        button.disabled = false;
      });
    };
  };
  const request = async (path,data) => {
    const response = await fetch(root+path,data ? {
      method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data)
    } : {headers:{Accept:'application/json'}});
    const result = await response.json();
    if (!response.ok || result.status || result.errors) throw new Error(config.unavailable || 'Unable to update your cart. Please try again.');
    return result;
  };
  const markedGift = item => giftProducts.has(String(item.product_id)) && String(item.properties?._dodWelcomeGift) === '1';
  const count = cart => cart.items.reduce((sum,item)=>sum + (games.has(String(item.product_id)) && !giftProducts.has(String(item.product_id)) && !item.gift_card && Number(item.original_price ?? item.price) > 0 ? item.quantity : 0),0);
  const normalize = values => values.map(value=>value.toUpperCase()).sort().join(',');
  const sync = (original,requestedSections,chosen) => {
    const release = begin();
    // change/update already return the full cart, including entered discount codes.
    // A queued reconciliation must fetch again because an earlier job may change it.
    const reuseCart = queuedSyncs === 0 && Array.isArray(original?.items) && Number.isInteger(original.item_count) && Array.isArray(original.discount_codes);
    queuedSyncs++;
    const run = async () => {
      let cart = reuseCart ? original : await request('cart.js');
      const sections = requestedSections || (Object.keys(original?.sections || {}).length ? Object.keys(original.sections) : ['cart-drawer','cart-icon-bubble']);
      let changed = false;
      let notice = '';
      if (offerReady) {
        if (chosen !== undefined) {
          if (!giftVariants.has(String(chosen))) throw new Error(config.unavailable);
          reserve(chosen);
        }
        const quantity = count(cart);
        let gifts = cart.items.filter(markedGift);
        if (!quantity) {
          if (!pending && gifts.length) reserve(gifts[0].variant_id);
          if (gifts.length) {
            cart = await request('cart/update.js',{updates:Object.fromEntries(gifts.map(item=>[item.key,0]))});
            changed = true;
          }
        } else {
          let selected = pending || String(gifts[0]?.variant_id || '');
          if (selected && !gifts.some(item=>String(item.variant_id) === selected)) {
            try {
              await request('cart/add.js',{items:[{id:Number(selected),quantity:1,properties:{_dodWelcomeGift:'1'}}]});
              cart = await request('cart.js');
              gifts = cart.items.filter(markedGift);
              changed = true;
            } catch (error) {
              reserve('');
              selected = String(gifts[0]?.variant_id || '');
              notice = config.unavailable;
            }
          }
          let retained = false;
          const updates = {};
          gifts.forEach(item=>{
            const keep = !retained && String(item.variant_id) === selected;
            if (keep) retained = true;
            const quantity = keep ? 1 : 0;
            if (item.quantity !== quantity) updates[item.key] = quantity;
          });
          if (Object.keys(updates).length) {
            cart = await request('cart/update.js',{updates});
            changed = true;
          }
          if (retained) reserve('');
        }
      }
      const quantity = count(cart);
      const useOffer = offerReady || cart.attributes?.dod_gift_offer === 'ln-oct2026' || cart.items.some(item => diceGames.includes(String(item.product_id)));
      const tier = useOffer ? (quantity ? offerCode : '') : quantity >= 4 ? 'CHATGAMES4-40' : quantity === 3 ? 'CHATGAMES3-30' : quantity === 2 ? 'CHATGAMES2-20' : '';
      const codes = (cart.discount_codes || []).map(item=>item.code);
      const desired = [...codes.filter(code=>!owned(code)),...(tier ? [tier] : [])];
      const attributes = useOffer ? {dod_gift_offer:'ln-oct2026'} : {};
      if (changed || normalize(codes) !== normalize(desired) || (useOffer && cart.attributes?.dod_gift_offer !== 'ln-oct2026')) {
        cart = await request('cart/update.js',{discount:desired.join(','),attributes,sections,sections_url:location.pathname});
      } else {
        cart = {...original,...cart,sections:original?.sections};
      }
      if (offerReady) {
        const chargedGifts = cart.items.filter(item=>markedGift(item) && Number(item.final_line_price) > 0);
        if (chargedGifts.length) {
          reserve('');
          cart = await request('cart/update.js',{updates:Object.fromEntries(chargedGifts.map(item=>[item.key,0])),sections,sections_url:location.pathname});
          notice = config.offer_unavailable;
        }
        const gift = cart.items.find(markedGift);
        document.dispatchEvent(new CustomEvent('dod:gift-state',{detail:{cart,selected:String(gift?.variant_id || pending),reserved:!gift && !!pending,message:notice}}));
      }
      return {...original,...cart,gift_notice:notice};
    };
    const result = queue.then(run,run);
    queue = result.catch(()=>{});
    return result.finally(()=>{queuedSyncs--;release();});
  };
  const render = cart => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && cart.sections && Object.values(cart.sections).every(Boolean)) {
      drawer.classList.toggle('is-empty',cart.item_count === 0);
      drawer.renderContents(cart,false);
    }
  };
  window.DODGameTiers = {sync,begin,count,selectGift:id=>sync(undefined,undefined,id),render,get busy(){return holds>0;}};
  document.addEventListener('submit',async event=>{
    if (event.submitter?.name !== 'checkout' || event.submitter.hasAttribute('data-qb-buy-now')) return;
    event.preventDefault();
    if (holds) return;
    try {
      const cart = await sync();
      render(cart);
      if (!cart.item_count) throw new Error(config.paid_required || 'Add a game before checkout.');
      location.assign(root+'checkout');
    } catch (error) {
      const status = document.querySelector('#CartDrawer-CartErrors, #cart-errors');
      if (status) status.textContent = error.message;
    }
  },true);
  const initialize = async () => {
    try { render(await sync()); }
    catch (error) {
      const status = document.querySelector('#CartDrawer-CartErrors');
      if (status) status.textContent = error.message;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
})();



